module.exports = __webpack_public_path__ + "img/PostgreSQL.fabaf1cf.png";